export default {
  component: () => import('./page.vue'),
  path: '/401',
  name: 'error-401',
  meta: {
    title: '登录失败',
  },
};
